import { render } from "./text3.vue?vue&type=template&id=2aed2b4c&scoped=true"
import script from "./text3.vue?vue&type=script&lang=js"
export * from "./text3.vue?vue&type=script&lang=js"

import "./text3.vue?vue&type=style&index=0&id=2aed2b4c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aed2b4c"]])

export default __exports__